module.exports = __webpack_public_path__ + "static/img/opacity.d4691e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/opacity.png
// module id = G4qZ
// module chunks = 0